export const POST_TEST_EMAIL_REQUEST = 'POST_TEST_EMAIL_REQUEST';
export const POST_TEST_EMAIL_SUCCESS = 'POST_TEST_EMAIL_SUCCESS';
export const POST_TEST_EMAIL_FAILURE = 'POST_TEST_EMAIL_FAILURE';
